// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3NCCb","subheader":"ReorderModal_subheader__3uybq","listWrap":"ReorderModal_listWrap__1UJUp"};